import { BillLineInstallmentStatus } from '@types'
import { MockFactory } from '@tino-frontend/mocks'
import { lineItemInstallment } from './installment'

const lineItemInstallmentEditedCopy = lineItemInstallment.build(
  {
    ...lineItemInstallment.source,
    metadata: {
      ...lineItemInstallment.source.metadata,
      versions: [
        {
          ...lineItemInstallment.source.metadata.versions[0]!,
          installment_internal_status: BillLineInstallmentStatus.Canceled,
        },
        {
          invoice_total_amount_cents: 30000,
          invoice_num_installments: 3,
          installment_edited_at: '2023-12-01T00:00:00Z',
          installment_number: 1,
          installment_total_amount_cents: 10000,
          installment_settlement_date: '2023-12-01T00:00:00Z',
          installment_estimated_due_date: '2023-12-01',
          installment_internal_status: BillLineInstallmentStatus.Open,
        },
      ],
      edition: {
        edited: true,
        canceled: false,
        reimbursed: false,
        lastEditionDate: '2023-12-01T00:00:00Z',
        newAmount: 30000,
        originalAmount: 20000,
      },
    },
  },
  { mergeArray: false }
)

export const lineItemInstallmentEdited = new MockFactory(
  lineItemInstallmentEditedCopy
)
